// -------------------------------------------------------------------- constants --------------------------------------------------------------------

// ***************************************************************** RulePacks *******************************************************************
const INDEX_STACK_RULE_PACKS_SUCCESS = "INDEX_STACK_RULE_PACKS_SUCCESS";
const SHOW_STACK_RULE_PACK_SUCCESS = "SHOW_STACK_RULE_PACK_SUCCESS";
const STORE_STACK_RULE_PACK_SUCCESS = "STORE_STACK_RULE_PACK_SUCCESS";
const UPDATE_STACK_RULE_PACK_SUCCESS = "UPDATE_STACK_RULE_PACK_SUCCESS";
const DESTROY_STACK_RULE_PACK_SUCCESS = "DESTROY_STACK_RULE_PACK_SUCCESS";
// ******************************************************************** rulePackRules **********************************************************************
const INDEX_STACK_RULE_PACK_RULES_SUCCESS =
  "INDEX_STACK_RULE_PACK_RULES_SUCCESS";
const SHOW_STACK_RULE_PACK_RULE_SUCCESS = "SHOW_STACK_RULE_PACK_RULE_SUCCESS";
const STORE_STACK_RULE_PACK_RULE_SUCCESS = "STORE_STACK_RULE_PACK_RULE_SUCCESS";
const UPDATE_STACK_RULE_PACK_RULE_SUCCESS =
  "UPDATE_STACK_RULE_PACK_RULE_SUCCESS";
const DESTROY_STACK_RULE_PACK_RULE_SUCCESS =
  "DESTROY_STACK_RULE_PACK_RULE_SUCCESS";

const INDEX_STACK_RULE_PACK_RULES_FORM_SUCCESS =
  "INDEX_STACK_RULE_PACK_RULES_FORM_SUCCESS";

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

// ***************************************************************** RulePacks *******************************************************************
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _indexSuccess(payload) {
  return {
    type: INDEX_STACK_RULE_PACKS_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showSuccess(payload) {
  return {
    type: SHOW_STACK_RULE_PACK_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _storeSuccess(payload) {
  return {
    type: STORE_STACK_RULE_PACK_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _updateSuccess(payload) {
  return {
    type: UPDATE_STACK_RULE_PACK_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {Number} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _destroySuccess(payload) {
  return {
    type: DESTROY_STACK_RULE_PACK_SUCCESS,
    payload: payload,
  };
}

// ******************************************************************** rulePackRules **********************************************************************
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _indexRulePackRulesSuccess(payload) {
  return {
    type: INDEX_STACK_RULE_PACK_RULES_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showRulePackRuleSuccess(payload) {
  return {
    type: SHOW_STACK_RULE_PACK_RULE_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _storeRulePackRuleSuccess(payload) {
  return {
    type: STORE_STACK_RULE_PACK_RULE_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _updateRulePackRuleSuccess(payload) {
  return {
    type: UPDATE_STACK_RULE_PACK_RULE_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {Number} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _destroyRulePackRuleSuccess(payload) {
  return {
    type: DESTROY_STACK_RULE_PACK_RULE_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showRule(payload) {
  return {
    type: INDEX_STACK_RULE_PACK_RULES_FORM_SUCCESS,
    payload: payload.data,
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------

// ***************************************************************** RulePackRules *******************************************************************
/**
 *
 * @param {Object} [params]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function process(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .post("/stacks/process", { params })
      .then((r) => {
        app.message("محاسبه سبد");
        callback(false, r);
      })
      .catch((e) => {
        app.message("خطا در محاسبه سبد", "error");
        callback(e);
      });
  };
}

/**
 *
 * @param {Object} [params]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function index(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get("/rule-packs", { params })
      .then((r) => {
        dispatch(_indexSuccess(r));
        callback(false, r);
      })
      .catch((e) => {
        callback(e);
      });
  };
}

/**
 *
 * @param {Number} rulePackRule
 * @param {Object} params
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function show(rulePackRule, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get(`/rule-packs/${rulePackRule}`, { params })
      .then((r) => {
        dispatch(_showSuccess(r));
        callback(r);
      })
      .catch((e) => {
        callback(e);
      });
  };
}

/**
 *
 * @param {Object} params
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function showForm(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get(`/rulePackRules`, { params })
      .then((res) => {
        dispatch(_showRule(res));
        callback(undefined, res);
      })
      .catch((err) => {
        app.error(
          err,
          "routes.home.attendance.rulePackRules",
          ".خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید",
          app.translate(".خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید")
        );
        callback(err);
      });
  };
}

/**
 *
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function store(data, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate(
        "routes.home.attendance.stack.packs.Adding New RulePackRule"
      )
    );

    api
      .post("/rule-packs", { data })
      .then((r) => {
        dispatch(_storeSuccess(r));
        loader.hide(() =>
          app.message(
            app.translate(
              "routes.home.attendance.stack.packs.New RulePackRule Added Successfully"
            )
          )
        );
        callback(r);
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.attendance.rulePackRule",
            "خطا در ارسال اطلاعات",
            app.translate(
              "routes.home.attendance.stack.packs.Adding New RulePackRule Failed"
            )
          )
        );
      });
  };
}

/**
 *
 * @param {Number} rulePackRule
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function update(rulePackRule, data, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate("routes.home.attendance.stack.packs.Updating RulePackRule")
    );

    api
      .put(`/rule-packs/${rulePackRule}`, { data })
      .then((r) => {
        dispatch(_updateSuccess(r));
        loader.hide(() =>
          app.message(
            app.translate(
              "routes.home.attendance.stack.packs.RulePackRule Updated Successfully"
            )
          )
        );
        callback(r);
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.attendance.rulePackRule",
            "عملیات بروزرسانی با شکست مواجه شد",
            app.translate(
              "routes.home.attendance.stack.packs.Updating RulePackRule Failed"
            )
          )
        );
      });
  };
}

/**
 *
 * @param {Number} rulePackRule
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function destroy(rulePackRule, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate("routes.home.attendance.stack.packs.Removing RulePackRule")
    );

    api
      .delete(`/rule-packs/${rulePackRule}`)
      .then((r) => {
        dispatch(_destroySuccess(rulePackRule));
        loader.hide(() =>
          app.message(
            app.translate(
              "routes.home.attendance.stack.packs.RulePackRule Removed Successfully"
            )
          )
        );
        callback(r);
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.attendance.rulePackRule",
            "عملیات حذف با شکست مواجه شد",
            app.translate(
              "routes.home.attendance.stack.packs.Removing RulePackRule Failed"
            )
          )
        );
      });
  };
}

/**
 *
 * @return {Function}
 */
export function emptyRulePacks() {
  return _indexSuccess({ data: { rulePacks: [] }, meta: {} });
}

/**
 *
 * @return {Function}
 */
export function emptyRule() {
  return _showRule({ data: { rule: {} } });
}

// ******************************************************************** rulePackRules **********************************************************************
/**
 *
 * @param {Object} [params]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function indexRulePackRules(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get("/rule-packs/rules", { params })
      .then((r) => {
        dispatch(_indexRulePackRulesSuccess(r));
        callback(r);
      })
      .catch((e) => {
        callback(e);
      });
  };
}

/**
 *
 * @param {Number} rulePackRule
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function showRulePackRule(
  rulePackRule,
  params = {},
  callback = () => {}
) {
  return (dispatch, gs, api) => {
    api
      .get(`/rule-packs/rules/${rulePackRule}`, { params })
      .then((res) => {
        dispatch(_showRulePackRuleSuccess(res));
        callback(undefined, res);
      })
      .catch((err) => {
        callback(err);
      });
  };
}

/**
 *
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function storeRulePackRule(data, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate(
        "routes.home.attendance.stack.packs.Adding New RulePackRule"
      )
    );

    api
      .post(`/rule-packs/rules`, { data })
      .then((r) => {
        dispatch(_storeRulePackRuleSuccess(r));
        loader.hide(() =>
          app.message(
            app.translate(
              "routes.home.attendance.stack.packs.New RulePackRule Added Successfully"
            )
          )
        );
        callback(r);
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.attendance.rulePackRule",
            "خطا در ارسال اطلاعات",
            app.translate(
              "routes.home.attendance.stack.packs.Adding New RulePackRule Failed"
            )
          )
        );
      });
  };
}

/**
 *
 * @param {Number} rulePackRule
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function updateRulePackRule(rulePackRule, data, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate("routes.home.attendance.stack.packs.Updating RulePackRule")
    );

    api
      .put(`/rule-packs/rules/${rulePackRule}`, { data })
      .then((r) => {
        dispatch(_updateRulePackRuleSuccess(r));
        loader.hide(() =>
          app.message(
            app.translate(
              "routes.home.attendance.stack.packs.RulePackRule Updated Successfully"
            )
          )
        );
        callback(r);
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.attendance.rulePackRule",
            "عملیات بروزرسانی با شکست مواجه شد",
            app.translate(
              "routes.home.attendance.stack.packs.Updating RulePackRule Failed"
            )
          )
        );
      });
  };
}

/**
 *
 * @param {Number} rulePackRule
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function destroyRulePackRule(rulePackRule, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate("routes.home.attendance.stack.packs.Removing RulePackRule")
    );

    api
      .delete(`/rule-packs/rules/${rulePackRule}`)
      .then((r) => {
        dispatch(_destroyRulePackRuleSuccess(rulePackRule));
        loader.hide(() =>
          app.message(
            app.translate(
              "routes.home.attendance.stack.packs.RulePackRule Removed Successfully"
            )
          )
        );
        callback(r);
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.attendance.rulePackRule",
            "عملیات حذف با شکست مواجه شد",
            app.translate(
              "routes.home.attendance.stack.packs.Removing RulePackRule Failed"
            )
          )
        );
      });
  };
}

/**
 *
 * @return {{type: String, payload: Object}}
 */
export function emptyRulePackRules() {
  return _indexRulePackRulesSuccess({ data: { rulePackRules: [] }, meta: {} });
}

/**
 *
 * @return {{type: String, payload: Object}}
 */
export function emptyRulePackRule() {
  return _showRulePackRuleSuccess({ data: { rulePackRule: {} } });
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {Object} state
 * @param {{type: String, payload: Object}} action
 * @return {Object}
 */
export default function reducer(
  state = {
    rulePacks: [],
    rulePack: {},
    rulePackRules: [],
    rulePackRule: {},
    metaRulePackRules: {},
  },
  action
) {
  let rulePacks = [];
  let rulePackRules = [];
  let rulePack = {};
  let _index;

  switch (action.type) {
    case INDEX_STACK_RULE_PACKS_SUCCESS:
      return Object.assign({}, state, {
        rulePacks: action.payload.data.rulePacks,
        metaRulePackRules: action.payload.meta,
      });
    case SHOW_STACK_RULE_PACK_SUCCESS:
      return Object.assign({}, state, {
        rulePack: action.payload.rulePack,
      });
    case STORE_STACK_RULE_PACK_SUCCESS:
      rulePacks = app._.clone(state.rulePacks);
      rulePacks.push(action.payload);
      return Object.assign({}, state, {
        rulePack: action.payload,
        rulePacks,
      });
    case UPDATE_STACK_RULE_PACK_SUCCESS:
      // rulePacks = app._.clone(state.rulePacks);
      // rulePack = app._.clone(state.rulePack);
      // _index = rulePacks.findIndex(
      //   (_rulePackRule) => _rulePackRule.id === action.payload.id
      // );
      // rulePacks[_index] = action.payload;
      // rulePack.name = action.payload.name;
      // rulePack.description = action.payload.description;
      return Object.assign({}, state, {
        rulePack,
        rulePacks,
      });
    case DESTROY_STACK_RULE_PACK_SUCCESS:
      rulePacks = app._.clone(state.rulePacks);
      _index = rulePacks.findIndex(
        (_rulePackRule) => _rulePackRule.id === action.payload
      );
      rulePacks.splice(_index, 1);
      return Object.assign({}, state, {
        rulePacks,
        rulePack: null,
        rulePackRule: null,
      });
    case INDEX_STACK_RULE_PACK_RULES_SUCCESS:
      return Object.assign({}, state, {
        rulePackRules: action.payload.data.rulePackRules,
        metaRulePackRules: action.payload.meta,
      });
    case SHOW_STACK_RULE_PACK_RULE_SUCCESS:
      return Object.assign({}, state, {
        rulePackRule: action.payload.rulePackRule,
      });
    case STORE_STACK_RULE_PACK_RULE_SUCCESS:
      rulePackRules = app._.cloneDeep(state.rulePackRules);
      rulePack = app._.cloneDeep(state.rulePack);
      let _rules = [];
      _rules.push(action.payload);
      if (!app._.isEmpty(rulePackRules)) {
        _rules.push(...rulePackRules);
      }
      rulePack.rulePackRules = _rules;
      return Object.assign({}, state, {
        rulePackRule: action.payload,
        rulePackRules: _rules,
        rulePack,
      });
    case UPDATE_STACK_RULE_PACK_RULE_SUCCESS:
      rulePackRules = app._.cloneDeep(state.rulePackRules);
      rulePack = app._.cloneDeep(state.rulePack);
      _index = rulePackRules.findIndex(
        (_rulePackRule) => _rulePackRule.id === action.payload.id
      );
      rulePackRules[_index] = action.payload;
      rulePack.rulePackRules = rulePackRules;
      return Object.assign({}, state, {
        rulePackRule: action.payload,
        rulePackRules,
        rulePack,
      });
    case DESTROY_STACK_RULE_PACK_RULE_SUCCESS:
      rulePackRules = app._.cloneDeep(state.rulePackRules);
      _index = rulePackRules.findIndex(
        (_rulePackRule) => _rulePackRule.id === action.payload
      );
      rulePackRules.splice(_index, 1);
      rulePack.rulePackRules = rulePackRules;
      return Object.assign({}, state, {
        rulePackRules,
        rulePack,
      });
    case INDEX_STACK_RULE_PACK_RULES_FORM_SUCCESS:
      return Object.assign({}, state, {
        rulePackRules: action.payload.rulePackRules,
      });
    default:
      return state;
  }
}
